import React from 'react';
import { Typography } from '@mui/material';
import { isTimeBeforeTimeNow } from 'services/utils/dateCalculations';
import useShopFormat from 'hooks/useShopFormat';
import { useTranslation } from 'services/localization/useTranslation';

interface OwnProps {
	creationDate: string;
	startDate: string | null;
}

type Props = OwnProps;

export const RentalCardStartTime = ({ creationDate, startDate }: Props) => {
	const dateExpired = startDate ? isTimeBeforeTimeNow(startDate) : true;
	const { localFormat } = useShopFormat();
	const { t } = useTranslation();
	const formattedStartDate = startDate ? localFormat(startDate, 'ddd D.M., HH:mm') : null;
	const formattedCreationDate = localFormat(creationDate, 'ddd D.M., HH:mm');
	return (
		<React.Fragment>
			<Typography variant="body2" color="textSecondary" align="right">
				{t('rentalCard.orderStart', 'Order start')}
			</Typography>
			{startDate ? (
				<React.Fragment>
					<Typography
						data-qa="startTime"
						variant="body1"
						color={dateExpired ? 'error' : 'initial'}
						align="right"
					>
						{formattedStartDate}
					</Typography>
				</React.Fragment>
			) : (
				<React.Fragment>
					<Typography variant="body1" color={dateExpired ? 'error' : 'initial'} align="right">
						{formattedCreationDate}
					</Typography>
				</React.Fragment>
			)}
		</React.Fragment>
	);
};

export default RentalCardStartTime;
